import { ENextRoundVariant, ETypeVaccine } from 'shared/api';

// Structural type covering both TDiseaseRound and TVaccineRound — they're identical in shape.
type SanitizableRound = {
  type_round: ENextRoundVariant;
  type_vaccination: ETypeVaccine;
  count_days?: number;
  count_days2?: number;
  count_years?: number;
  isPeriodicRevactination: boolean;
};

// Drops fields that are not legitimate for the current round configuration.
// Domain rules: count_years exists only for periodic ReVaccination rounds;
// count_days/count_days2 don't apply to periodic rounds or to type_round=any_days;
// isPeriodicRevactination + count_years are meaningless for Vaccination.
export const sanitizeRound = <T extends SanitizableRound>(round: T): T => {
  const out = { ...round };

  if (out.type_vaccination === ETypeVaccine.Vaccination) {
    out.isPeriodicRevactination = false;
    out.count_years = undefined;
  }

  if (out.isPeriodicRevactination) {
    out.count_days = undefined;
    out.count_days2 = undefined;
  } else {
    out.count_years = undefined;
  }

  if (out.type_round === ENextRoundVariant.AnyDays) {
    out.count_days = undefined;
    out.count_days2 = undefined;
  }

  return out;
};
